import { Tooltip } from "antd"
import type { TooltipPlacement } from "antd/es/tooltip"
import React from "react"

// UI/UX guidelines §5.16: hover, 300ms, clarification only. Focus is included
// so an icon-only control explains itself to keyboard users too.
const TOOLTIP_DELAY_SECONDS = 0.3

interface ActionTooltipProps {
  title: React.ReactNode
  placement?: TooltipPlacement
  children: React.ReactNode
}

/**
 * Label for an icon-only control. One component so Reports and Home cannot
 * drift apart on delay or placement.
 */
export const ActionTooltip = ({
  title,
  placement = "top",
  children
}: ActionTooltipProps) => (
  <Tooltip
    title={title}
    placement={placement}
    mouseEnterDelay={TOOLTIP_DELAY_SECONDS}
    trigger={["hover", "focus"]}
  >
    {children}
  </Tooltip>
)
